import { apiAgent } from "../../../axiosConfig"
import getApiUrl from "../../utils/UrlHelper"

export const get_data_exports = (data_params) => {
    return apiAgent({
        method: "get",
        url: getApiUrl('get_data_exports'),
        params: data_params
    })
}
